<template>
  <div>
    <el-table
      :data="process_list"
      style="width: 100%">
    
    <el-table-column 
      prop="process_name"
      label="Process Name">
        <template slot-scope="scope">
          {{ scope.row.process_name }} {{scope.row.extra_charge>0 ? '@ '+formatCurrency(parseFloat(scope.row.extra_charge)) : ''}}
        </template>
    </el-table-column>
    <el-table-column 
      prop="option_list"
      label="Options">
      <template slot-scope="scope" v-if="scope.row.option_list.length>0">
        <el-select 
            :disabled="!scope.row.is_required"
            size="small"
            style="width: 200px;"
            v-model="scope.row.process_option_id" 
            filterable>
            <el-option
                v-for="(data, index) in scope.row.option_list"
                :key="index"
                :label="data.option_name"
                :value="data.id">
                  <div style="display: flex; flex-direction: row; height: 200px !important;">
                    <img class="selectImg" :src="data.image" style=" margin: 5px; height: 200px !important;"> 
                    <span style=" margin: 5px;">{{ data.option_name }} @ {{formatCurrency(parseFloat(data.extra_charge))}}</span>
                  </div>
                  
            </el-option>
        </el-select>
        
      </template>
    </el-table-column>
      <el-table-column
      prop="additional_notes"
      label="Remarks">
          <template slot-scope="scope">
              <el-input @focus="$event.target.select()"
                  :disabled="!scope.row.is_required || scope.row.hidden_process >= 0"
                  v-model="scope.row.additional_notes"
                  size="small">
              </el-input>
          </template>
      </el-table-column>
      <el-table-column
      label="Add as Add-On?" align="right">
        <template slot-scope="scope">
          <el-checkbox @change="disableOtherAddOns" :disabled="!scope.row.add_on_process_eligible" v-model="scope.row.add_on_process">
            Yes
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
      label="Sub-Processes" align="center">
        <template slot-scope="scope">
          <el-checkbox 
            v-for="sub_process in scope.row.sub_process_list"
            :key="sub_process.id"
            v-model="sub_process.is_required">
            {{ sub_process.process_name }}
          </el-checkbox>

        </template>
      </el-table-column>
      <el-table-column
      prop="is_required"
      label="Required?" align="right">
        <template slot-scope="scope">
          <el-checkbox :disabled="scope.row.hidden_process >= 0" v-model="scope.row.is_required">
            Yes
          </el-checkbox>
        </template>
      </el-table-column>
     
  </el-table>
  </div>
</template>

<script>
export default {
    props: ['process_list']
}
</script>

<style scoped>
  .selectImg {
    width: 150px;
    height: 150px;
  }
</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/ProcessList.vue